/**
 * Route wrapper for the signature creation flow.
 *
 * @module Pages/Signatures
 */

import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { SignatureCreate } from './Components/SignatureCreate';
import { MainContent } from '@/Templates/Main/MainContent/MainContent';

export const SignatureCreatePage = (): JSX.Element => {
  const navigate = useNavigate();
  const backToList = () => {
    navigate('/signatures');
  };

  return (
    <MainContent id='signature-create' styling={{ noBackgroundColor: true, noBorder: true }}>
      <SignatureCreate onBack={backToList} onSuccess={backToList} />
    </MainContent>
  );
};
